import { Subscription } from './type';

export const MANAGE_SUBSCRIPTION_PLANS_FILTERS = {
  all: 'all',
  basicPlan: 'basicPlan',
  premiumPlan: 'premiumPlan',
  expiringSoon: 'expiringSoon',
} as const;

export const dummySubscriptions: Subscription[] = [
  {
    id: '1',
    plan: 'premium',
    paymentType: 'monthly',
    due: 'Auto renews on September 17, 2024 Next Payment 9.00',
  },
  {
    id: '2',
    plan: 'premium',
    paymentType: 'annual',
    due: 'Auto renews on September 17, 2024 Next Payment 90.00',
  },
  {
    id: '3',
    plan: 'initial',
    paymentType: 'initial',
    due: 'Ends on March 29, 2026',
  },
  {
    id: '4',
    plan: 'initial',
    paymentType: 'initial',
    due: 'Ends on September 17, 2024 2024 Upgrade for full access',
  },
  {
    id: '5',
    plan: 'basic',
  },
  {
    id: '6',
    plan: 'basic',
  },
];
